/**
 * Created by Victor Rojo on 30/8/18.
 */
import {Component, Input, EventEmitter} from '@angular/core';
@Component({
  selector: 'tree-view',
  templateUrl: './TreeView.html',
  styleUrls: ['./TreeView.css']
})
export class TreeViewComponent {
  @Input() node: any;
  @Input() nodeLevel: number;
  private _expandedNodeLevels = 0;
  @Input()
  set expandedNodeLevels(expand:number) {
    this._expandedNodeLevels = expand;
    this.open = this.nodeLevel <= expand;
  }
  @Input() selectedNodeId:any;
  open:boolean = false;
  active:boolean = false;
  @Input() nodeSelected: EventEmitter<any>;

  public onNodeSelected(e:any): void {
    this.nodeSelected.emit(this.node);
  }

  toggleMenu(event:any) {
    event.stopPropagation();
    this.open = !this.open;
  }
}
